import React from 'react';
import { BRAND } from '../data/site';
export function SiteFooter() {
  return <footer className="w-full bg-sage-800 px-5 py-14 text-center sm:px-8" data-id="element-193" data-mp="3r8j5b1nlzaor">
      <p className="font-serif text-2xl text-cream" data-id="element-194" data-mp="3racbygy81uwr">{BRAND.name}</p>
      <p className="mt-3 text-[12px] uppercase tracking-[0.18em] text-sage-200" data-id="element-195" data-mp="3mg83ft9b5etk">
        Manualidades botánicas · Guías digitales
      </p>
      <p className="mt-6 text-[11.5px] text-sage-300" data-id="element-196" data-mp="3hglptipkhwk8">
        © {new Date().getFullYear()} {BRAND.name}. Todos los derechos reservados.
      </p>
    </footer>;
}